import React from 'react';

import svg from './assets/icons-24-info.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconInfo = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-info" />;
